<template>
  <v-dialog v-model="dialog.show"
            max-width="360px">
    <v-card>
      <v-card-title class="headline primary"
                    primary-title>
        <span style="color: white">{{dialog.title}}</span>
      </v-card-title>

      <v-card-text>{{dialog.text}}</v-card-text>

      <v-divider class="primary"></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary"
               text
               @click="onClick">OK</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "vue-ongeo-ok-dialog",
  props: {
    dialog: {
      type: Object,
      default: function () {
        return { show: false, title: "Informacja", text: "", callback: null };
      }
    }
  },
  methods: {
    onClick: function () {
      if (this.dialog.callback) this.dialog.callback();
      this.dialog.show = false;
    }
  }
};
</script>

<style lang="scss">
.v-dialog > .v-card > .v-card__text {
  padding: 24px 20px;
}
</style>